import Component from "@ember/component"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"

class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

export default class AdminSidebarUser extends Component {
  @service("ember-store")
  store

  @service
  rpc

  @service
  session

  @service
  notifier

  canShowActionMenu = false
}
